"use client";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { removeLeadingHashNumber } from "@/lib/utils";
import {
  ChevronRight,
  Gift,
  MapPin,
  MenuIcon,
  ShoppingBag,
  Users,
  WineIcon,
} from "lucide-react";
import Link from "next/link";
import data from "../../../../data/static-categories.json";
import { itemsLeft, itemsProps, itemsRight } from "./data";
export default function HamburgerMenu() {
  return (
    <Sheet>
      <SheetTrigger aria-label="öppna hamburgermeny">
        <MenuIcon className="text-primary-foreground w-[32px] h-[32px]" />
      </SheetTrigger>
      <SheetContent className="flex flex-col">
        <SheetHeader className="text-left">
          <SheetTitle>Wine Club</SheetTitle>
          <SheetDescription className="text-md">
            Upptäck vinets värld med våra unika provningar ledda av erfarna
            sommelierer. Perfekt för både nybörjare och vinälskare.
          </SheetDescription>
        </SheetHeader>
        <ScrollArea>
          <Collapsible
            key="menu"
            defaultOpen={false}
            className="group/collapsible font-poppins"
          >
            <CollapsibleTrigger className="w-full hover:underline  mb-2">
              <div className="flex items-center justify-between py-4 w-full h-[64px] gap-2 ">
                <span className="flex items-center gap-2">
                  <WineIcon className="size-8" strokeWidth={1} />
                  <span className="text-sm">Våra Provningar</span>
                </span>
                <ChevronRight className="ml-auto size-4 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
              </div>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <menu className="border-l pl-4 ml-2 flex flex-col">
                {/* <li className="hover:underline text-sm">
                  <Link href="/vara-provningar">Alla Provningar</Link>
                </li> */}
                {data?.map((item) => (
                  <li className="hover:underline text-sm py-2" key={item.id}>
                    <Link href={`/vara-provningar/${item.slug}`}>
                      <SheetClose className="h-[48px] w-full text-left hover:underline">
                        {item?.name && removeLeadingHashNumber(item.name)}
                      </SheetClose>
                    </Link>
                  </li>
                ))}
              </menu>
            </CollapsibleContent>
          </Collapsible>
          <menu className="">
            {itemsLeft?.map((item) =>
              item.children ? (
                <CollapsibleItem key={item.id} item={item} />
              ) : (
                <li
                  className="hover:underline text-sm py-2 font-poppins flex gap-2 items-center"
                  key={item.id}
                >
                  <Link href={item.href} className="w-full h-[64px]">
                    <SheetClose className="flex gap-2 items-center  w-full h-full">
                      {item.title === "Presentkort" && (
                        <Gift strokeWidth={1} className="size-8" />
                      )}
                      {item?.title}
                    </SheetClose>
                  </Link>
                </li>
              )
            )}
            {itemsRight?.map((item) =>
              item.children ? (
                <CollapsibleItem key={item.id} item={item} />
              ) : (
                <li
                  className="hover:underline text-sm py-2 font-poppins flex gap-2 items-center"
                  key={item.id}
                >
                  <Link href={item.href} className="w-full h-[64px]">
                    <SheetClose className=" w-full text-left h-full flex items-center gap-2">
                      {item.title === "Hitta hit" && (
                        <MapPin strokeWidth={1} className="size-8" />
                      )}
                      {item?.title}
                    </SheetClose>
                  </Link>
                </li>
              )
            )}
          </menu>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}

const CollapsibleItem = ({ item }: { item: itemsProps }) => {
  return (
    <Collapsible
      key={item.title}
      defaultOpen={false}
      className="group/collapsible font-poppins"
    >
      <CollapsibleTrigger className="w-full hover:underline ">
        <div className="flex items-center justify-between py-4 w-full gap-2 ">
          <span className="flex items-center gap-2 w-full">
            {item.title === "Produkter" && (
              <ShoppingBag strokeWidth={1} className="size-8" />
            )}
            {item.title === "Om oss" && (
              <Users strokeWidth={1} className="size-8" />
            )}
            {/* <UsersIcon className="size-8" strokeWidth={1} /> */}
            <span className="text-sm">{item.title}</span>
          </span>
          <ChevronRight className="ml-auto size-4 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <menu className="border-l pl-4 pt-2 pb-2 ml-2 flex flex-col">
          <li className="hover:underline text-sm py-2 flex">
            <Link href={item.href} className="w-full h-[64px]">
              <SheetClose className=" w-full text-left h-full flex items-center gap-2">
                {item.title}
              </SheetClose>
            </Link>
          </li>
          {item.children?.map((child: itemsProps) => (
            <li className="hover:underline text-sm py-2 flex" key={child.id}>
              <Link href={child.href} className="w-full h-[64px]">
                <SheetClose className="w-full text-left h-full flex items-center gap-2">
                  {child.title}
                </SheetClose>
              </Link>
            </li>
          ))}
        </menu>
      </CollapsibleContent>
    </Collapsible>
  );
};
